import { render, staticRenderFns } from "./TwoColumnMapCopy.vue?vue&type=template&id=06a8eefc&scoped=true&"
import script from "./TwoColumnMapCopy.vue?vue&type=script&lang=js&"
export * from "./TwoColumnMapCopy.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnMapCopy.vue?vue&type=style&index=0&id=06a8eefc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8eefc",
  null
  
)

export default component.exports